module.exports = __webpack_public_path__ + "static/media/certificate-lukasz-macon-my-portfolio-hm.c4e10485.pdf";